// Iter 31hh: utilità aggiornamento forzato dell'app (PWA).
// Risolve il problema degli utenti (non-admin su mobile) bloccati su una
// versione vecchia in cache che causa errori tipo "account non trovato".
import { APP_VERSION } from "@/version";

/**
 * Confronta la versione del bundle in esecuzione (APP_VERSION) con quella
 * pubblicata sul server (/version.json, sempre via rete grazie al
 * cache-buster). Ritorna la versione nuova se diversa, altrimenti null.
 */
export async function checkForNewVersion() {
  try {
    const res = await fetch(`/version.json?ts=${Date.now()}`, {
      cache: "no-store",
    });
    if (!res.ok) return null;
    const data = await res.json();
    const latest = data && data.version;
    return latest && latest !== APP_VERSION ? latest : null;
  } catch {
    return null; // offline o file mancante: nessun banner
  }
}

/**
 * Aggiornamento forzato: de-registra i service worker, svuota TUTTE le
 * cache e ricarica la pagina con cache-buster. Dopo il reload il browser
 * scarica il bundle nuovo e re-registra il service worker aggiornato.
 */
export async function forceAppUpdate() {
  try { sessionStorage.setItem("app_just_updated", "1"); } catch { /* ignore */ }
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if (window.caches) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {
    /* anche se la pulizia fallisce, ricarichiamo comunque */
  }
  window.location.replace(`${window.location.pathname}?updated=${Date.now()}`);
}

/**
 * Iter 45: se l'app è appena stata aggiornata (flag in sessionStorage messo
 * prima del reload), ritorna la versione corrente per mostrare la conferma
 * "stai usando l'ultima versione". Altrimenti null.
 */
export function notifyIfJustUpdated() {
  try {
    if (sessionStorage.getItem("app_just_updated") === "1") {
      sessionStorage.removeItem("app_just_updated");
      return APP_VERSION;
    }
  } catch { /* storage non disponibile */ }
  return null;
}
